import React from 'react'
import COLORS from 'styles/colors'
import { SVGProps } from 'types/svg'

const defaultSize = {
  width: 20,
  height: 20,
}

const PlusSign = ({ style, color = COLORS.brand.primary }: SVGProps) => (
  <svg style={{ ...defaultSize, ...style }} viewBox='0 0 19.493 20.703'>
    <path
      data-name='plus sign'
      d='M11.563 8.301h7.93v3.418h-7.93v8.984H7.93v-8.984H0V8.301h7.93v-8.3h3.633z'
      fill={color}
    />
  </svg>
)

export default PlusSign
